import "@fontsource-variable/inter";
import "@fontsource-variable/inter-tight";
import "@fontsource-variable/jetbrains-mono";
import "./styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app";
import { loadSession } from "./lib/auth";
import { persistStorage } from "./lib/db";
import { appBase } from "./lib/env";
import { loadProjects } from "./project/store";

async function boot() {
  await Promise.all([loadSession(), loadProjects()]);
  void persistStorage();
  if ("serviceWorker" in navigator && import.meta.env.PROD) {
    navigator.serviceWorker.register(`${appBase}sw.js`, { scope: appBase }).catch(() => undefined);
  }
  const root = document.getElementById("root");
  if (!root) throw new Error("#root missing from index.html");
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
